import axios from 'axios';

import {getCustomerUrl} from '~/utils/customer-util';
import {StatusCodes} from "http-status-codes";
import {CommonWorktag} from "~/types/common-worktag-type.ts";

export default class WorktagService {
    static async loadWorktags(cNum: string, serverBase: string) {
        const url: string = getCustomerUrl(cNum, `${serverBase}/chartfields`);
        const resp = await axios.get(url);
        return resp.status === StatusCodes.OK ? resp.data._embedded.chartFieldList : undefined;
    }

    static async loadCommonWorktags(cNum: string, serverBase: string) {
        const url: string = getCustomerUrl(cNum, `${serverBase}/localchartfields`);
        const resp = await axios.get(url);
        if (resp.status === StatusCodes.OK) {
            return resp.data._embedded.chartFieldList;
        }
        return resp.status === StatusCodes.NO_CONTENT ? [] : undefined;
    }

    static async updateCommonWorktags(cNum: string, serverBase: string, commonWorktags: CommonWorktag[]) {
        const url: string = getCustomerUrl(cNum, `${serverBase}/localchartfields`);
        const resp = await axios.put(url, commonWorktags);
        return resp;
    }

    static async saveCommonWorktags(cNum: string, serverBase: string, commonWorktags: CommonWorktag[]) {
        const url: string = getCustomerUrl(cNum, `${serverBase}/localchartfields`);
        const resp = await axios.post(url, commonWorktags);
        return resp;
    }

    static async deleteCommonWorktags(cNum: string, serverBase: string, commonWorktagIds: string[]) {
        const url: string = getCustomerUrl(cNum, `${serverBase}/localchartfields`);
        const resp = await axios.delete(url, {data: commonWorktagIds});
        return resp;
    }
}
